import { render } from "./Summer2024.vue?vue&type=template&id=4d0852e2&scoped=true"
import script from "./Summer2024.vue?vue&type=script&lang=js"
export * from "./Summer2024.vue?vue&type=script&lang=js"

import "./Summer2024.vue?vue&type=style&index=0&id=4d0852e2&lang=scss"
import "./Summer2024.vue?vue&type=style&index=1&id=4d0852e2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0852e2"]])

export default __exports__